import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/ProgressList'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { progressList } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = progressList.name
  static widget = Widget
  static configure = createConfigure(progressList)
}
